const state = {
  userInfo: {
    menus: []
  },
  nav: [],
  rasPublicKey: '',
  tabsOn: {
    path: "home",
    component: "/home/index",
    name: "首页",
    redirect: "",
    children: [],
    meta: {
      icon: "home"
    },
  },
  tabsList: [],
  permissionCodes: null,
  auditCalendar_queryDate: null,
  auditCalendar_station: null,
  ywjl_queryDate: null,
  loading: false,
  drawerTable: true,
  taskDetail: null,
  shjdblData: null,
  zssjData: null,
  pzgl: null, //告警记录处理 跳转 凭证管理,
  adminName: null,
  YQYD: null,
  addTask: null,
  lastTab:null,
};

const mutations = {
  SET_USERINFO: (state, v) => {
    state.userInfo = v;
  },
  SET_NAV: (state, v) => {
    state.nav = v;
  },
  SET_RASPUBLICKEY: (state, v) => {
    state.rasPublicKey = v;
  },
  SET_TABSLIST: (state, v) => {
    state.tabsList = v;
  },
  SET_TABSON: (state, v) => {
    state.tabsOn = v;
  },
  SET_PERMISSIONCODES: (state, v) => {
    state.permissionCodes = v;
  },
  SET_AUDITCALENDAR_QUERYDATE: (state, v) => {
    state.auditCalendar_queryDate = v;
  },
  SET_AUDITCALENDAR_STATION: (state, v) => {
    state.auditCalendar_station = v;
  },
  SET_YWJL_QUERYDATE: (state, v) => {
    state.ywjl_queryDate = v;
  },
  SET_LOADING: (state, v) => {
    state.loading = v;
  },
  SET_DRAWER_TABLE: (state, v) => {
    state.drawerTable = v;
  },
  SET_TASK_DETAIL: (state, v) => {
    state.taskDetail = v;
  },
  SET_STATION_TABS_ON: (state, v) => {
    state.stationTabsOn = v;
  },
  SET_SHJDBL_DATA: (state, v) => {
    state.shjdblData = v;
  },
  SET_ZSSJDATA: (state, v) => {
    state.zssjData = v;
  },
  SET_PZGL: (state, v) => {
    state.pzgl = v;
  },
  SET_ADMINNAME: (state, v) => {
    state.adminName = v;
  },
  SET_YQYD: (state, v) => {
    state.YQYD = v;
  },
  SET_ADDTASK: (state, v) => {
    state.addTask = v;
  },
  SET_LASTTAB: (state, v) => {
    state.lastTab = v;
  },
};

const actions = {
  setUserInfo({
    commit
  }, v) {
    commit("SET_USERINFO", v);
  },
  setNav({
    commit
  }, v) {
    commit("SET_NAV", v);
  },
  setRasPublicKey({
    commit
  }, v) {
    commit("SET_RASPUBLICKEY", v);
  },
  setTabsList({
    commit
  }, v) {
    commit("SET_TABSLIST", v);
  },
  setTabsOn({
    commit
  }, v) {
    commit("SET_TABSON", v);
  },
  setPermissionCodes({
    commit
  }, v) {
    commit("SET_PERMISSIONCODES", v);
  },
  setAuditCalendar_queryDate({
    commit
  }, v) {
    commit("SET_AUDITCALENDAR_QUERYDATE", v);
  },
  setAuditCalendar_station({
    commit
  }, v) {
    commit("SET_AUDITCALENDAR_STATION", v);
  },
  setYwjl_queryDate({
    commit
  }, v) {
    commit("SET_YWJL_QUERYDATE", v);
  },
  setLoading({
    commit
  }, v) {
    commit("SET_LOADING", v);
  },
  setDrawerTable({
    commit
  }, v) {
    commit("SET_DRAWER_TABLE", v);
  },
  setTaskDetail({
    commit
  }, v) {
    commit("SET_TASK_DETAIL", v);
  },
  setStationsObj({
    commit
  }, v) {
    commit("SET_STATIONSOBJ", v);
  },
  setStationTabsOn({
    commit
  }, v) {
    commit("SET_STATION_TABS_ON", v);
  },
  setShjdblData({
    commit
  }, v) {
    commit("SET_SHJDBL_DATA", v);
  },
  setZssjData({
    commit
  }, v) {
    commit("SET_ZSSJDATA", v);
  },
  setPzgl({
    commit
  }, v) {
    commit("SET_PZGL", v);
  },
  setAdminName({
    commit
  }, v) {
    commit("SET_ADMINNAME", v);
  },
  setYQYD({
    commit
  }, v) {
    commit("SET_YQYD", v);
  },
  setAddTask({
    commit
  }, v) {
    commit("SET_ADDTASK", v);
  },
  setLastTab({
    commit
  }, v) {
    commit("SET_LASTTAB", v);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/store.js